import { Theme } from '../types';

export const cyberpunkTheme: Theme = {
  name: 'cyberpunk',
  colors: {
    gray: {
      50: '#0a0a0f',
      100: '#141420',
      200: '#1f1f35',
      300: '#2a2a4a',
      400: '#35355f',
      500: '#404074',
      600: '#4b4b89',
      700: '#56569e',
      800: '#6161b3',
      900: '#6c6cc8',
    },
    accent: {
      50: '#f0f0ff',
      100: '#e0e0ff',
      200: '#d0d0ff',
      300: '#b3b3ff',
      400: '#9999ff',
      500: '#00ffff',
      600: '#00e6e6',
      700: '#00cccc',
      800: '#00b3b3',
      900: '#009999',
    },
    semantic: {
      success: '#00ff41',
      successLight: '#ccffdd',
      error: '#ff0080',
      errorLight: '#ffcce6',
      warning: '#ffff00',
      warningLight: '#ffffcc',
      info: '#00ffff',
      infoLight: '#ccffff',
    },
    background: {
      app: '#0a0a0f',
      surface: '#141420',
      elevated: '#1f1f35',
      navbar: '#141420',
      sidebar: '#1f1f35',
      hover: '#2a2a4a',
      active: '#35355f',
      blueprint: 'linear-gradient(135deg, #0a0a0f 0%, #2a2a4a 100%)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#00ffff',
      tertiary: '#6c6cc8',
      disabled: '#404074',
      inverse: '#0a0a0f',
      accent: '#00ff41',
      onAccent: '#0a0a0f',
      muted: '#4b4b89',
    },
    border: {
      color: '#35355f',
      light: '#2a2a4a',
      medium: '#404074',
    },
    button: {
      bg: '#141420',
      bgHover: '#1f1f35',
      bgActive: '#2a2a4a',
      text: '#00ffff',
      border: '#35355f',
      primary: {
        bg: '#00ffff',
        bgHover: '#00e6e6',
        bgActive: '#00cccc',
        text: '#0a0a0f',
      },
      disabled: {
        bg: '#1f1f35',
        text: '#404074',
        border: '#2a2a4a',
      },
    },
    input: {
      bg: '#141420',
      border: '#35355f',
      borderHover: '#404074',
      borderFocus: '#00ffff',
      text: '#ffffff',
      placeholder: '#4b4b89',
    },
    toggle: {
      bg: '#35355f',
      bgActive: '#00ffff',
      thumb: '#ffffff',
    },
    executing: '#ff0080',
    focus: '#00ffff',
    overlay: {
      light: 'rgba(0, 255, 255, 0.1)',
      medium: 'rgba(0, 255, 255, 0.2)',
      heavy: 'rgba(0, 255, 255, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(0, 255, 255, 0.25)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Roboto Mono', 'Courier New', monospace",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '2px',
    md: '4px',
    lg: '8px',
    full: '9999px',
    // Legacy border radius
    small: '2px',
    medium: '4px',
  },
  shadows: {
    xs: '0 0 5px rgba(0, 255, 255, 0.2)',
    sm: '0 0 10px rgba(0, 255, 255, 0.3)',
    md: '0 0 20px rgba(0, 255, 255, 0.4)',
    lg: '0 0 30px rgba(0, 255, 255, 0.5)',
    xl: '0 0 40px rgba(0, 255, 255, 0.6)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '100ms linear',
    base: '150ms linear',
    slow: '200ms linear',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};


